
<template>
  <div style="padding: 20px;">
    <el-card class="box-card">
      <el-form :inline="true" class="demo-form-inline" size="small" :model="searchForm" ref="searchForm">
        <el-form-item label="公司名称" prop="company_name">
          <el-input placeholder="公司名称" v-model="searchForm.company_name"></el-input>
        </el-form-item>
        <el-form-item label="地区" prop="area">
          <el-input placeholder="地区" v-model="searchForm.area"></el-input>
        </el-form-item>
        <el-form-item label="行业" prop="industry">
          <el-select placeholder="行业" v-model="searchForm.industry" clearable>
            <el-option v-for="item in industryOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="语义检索" prop="question" style="width: 300%;">
          <el-input
            placeholder="请输入你想问的问题，例如：'跟金融相关的公司？'"
            v-model="searchForm.question"
            type="textarea"
            :rows="1"
            style="width: 378%;"
          ></el-input>
        </el-form-item>
        <el-row type="flex" justify="center">
          <el-button size="small" type="primary" @click="clickSearch">筛选</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </el-row>
      </el-form>
    </el-card>
    
    <el-card class="box-card" style="margin-top: 25px;">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-grid"></i>公司信息</span>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" v-model="tableData">
          <el-table-column prop="company_name" label="公司名称" width="100">
            <template slot-scope="scope">
              <router-link :to="{ name: 'company_detail', params: { id: scope.row.company_name } }" @click.native.prevent="checkCompanyDetail(scope.row.company_name)">
                {{ scope.row.company_name }}
              </router-link>
            </template>
          </el-table-column>
          <el-table-column prop="company_introduction" label="公司信息" width="300">
            <template slot-scope="scope">
              <el-tooltip effect="dark" placement="top" v-if="scope.row.company_introduction">
                <div slot="content">{{ scope.row.company_introduction }}</div>
                <span>{{ scope.row.company_introduction.substring(0, 50) }}...</span>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_list" label="产品信息" width="500">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" v-if="scope.row.product_list && scope.row.product_list.length">
                <div style="max-height: 200px; overflow-y: auto;">
                  <p v-for="(product, index) in scope.row.product_list" :key="index">{{ product }}</p>
                </div>
                <div slot="reference">{{ (scope.row.product_list || []).join(', ').substring(0, 50) }}...</div>
              </el-popover>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="company_news_list" label="最近新闻" width="500">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" v-if="scope.row.company_news_list && scope.row.company_news_list.length">
                <div style="max-height: 200px; overflow-y: auto;">
                  <p v-for="(news, index) in scope.row.company_news_list" :key="index">{{ news }}</p>
                </div>
                <div slot="reference">{{ (scope.row.company_news_list || []).join(', ').substring(0, 50) }}...</div>
              </el-popover>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="concat_email_list" label="邮箱" width="200">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" v-if="scope.row.concat_email_list && scope.row.concat_email_list.length">
            <div style="max-height: 200px; overflow-y: auto;">
              <el-checkbox-group v-model="selectedEmails">
                <el-checkbox v-for="(email, index) in scope.row.concat_email_list" :key="index" :label="email">{{ email }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div slot="reference">{{ scope.row.concat_email_list.join(', ').substring(0, 50) }}{{ scope.row.concat_email_list.length > 50 ? '...' : '' }}</div>
          </el-popover>
          <span v-else>暂无邮箱信息</span>
        </template>
      </el-table-column>
          <el-table-column prop="concat_address" label="地址" width="100">
            <template slot-scope="scope">
              <el-tooltip effect="dark" placement="top" v-if="scope.row.concat_address">
                <div slot="content">{{ scope.row.concat_address }}</div>
                <span>{{ scope.row.concat_address.substring(0, 20) }}...</span>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="industry" label="行业" width="100"></el-table-column>
          <el-table-column prop="concat_phone" label="联系方式"  width="100"></el-table-column>
          
          <el-table-column prop="company_leader" label="负责人" width="100"></el-table-column>
          <el-table-column prop="leader_experience" label="负责人经历" width="100">
            <template slot-scope="scope">
              <el-tooltip effect="dark" placement="top" v-if="scope.row.leader_experience">
                <div slot="content">{{ scope.row.leader_experience }}</div>
                <span>{{ scope.row.leader_experience.substring(0, 20) }}...</span>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="company_customer" label="客户信息" width="100">
            <template slot-scope="scope">
              <el-tooltip effect="dark" placement="top" v-if="scope.row.company_customer">
                <div slot="content">{{ scope.row.company_customer }}</div>
                <span>{{ scope.row.company_customer.substring(0, 20) }}...</span>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="company_history" label="发展历史" width="500">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top" v-if="scope.row.company_history">
                <div style="max-height: 200px; overflow-y: auto;">{{ scope.row.company_history }}</div>
                <div slot="reference">{{ scope.row.company_history.substring(0, 50) }}...</div>
              </el-popover>
              <span v-else>-</span>
            </template>
          </el-table-column>
          
        </el-table>
      </div>
      <el-row type="flex" justify="end" style="margin-top: 30px;">
        <el-pagination
          :total="page.totalCount"
          :page-size="page.perPageSize"
          background
          layout="prev, pager, next, jumper"
          @current-change="handleCurrentChange">
        </el-pagination>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import axios from 'axios';
var host = 'https://www.haomiaodata.com/api/';

export default {
  name: "company_info",
  data() {
    return {
      searchForm: {
        company_name: "",
        area: "",
        industry: "",
        bid_company: "",
        email: "",
        phone: ""
      },
      selectedEmails: [], // 添加这一行
      tableData: [],
      cityOptions: [
      ],
      industryOptions : [
      { label: 'IT', value: 'IT' },
      { label: '制造业', value: '制造业' },
      { label: '医疗', value: '医疗' },
      { label: '教育', value: '教育' },
      { label: '消防设备', value: '消防设备' },
      { label: '其他', value: '其他' },
      { label: '通信服务', value: '通信服务' },
      { label: '工程建设', value: '工程建设' },
      { label: '工程咨询服务', value: '工程咨询服务' },
      { label: '建筑幕墙工程', value: '建筑幕墙工程' },
      { label: '装饰装修工程', value: '装饰装修工程' },
      { label: '专业服务', value: '专业服务' },
      { label: '专用设备', value: '专用设备' },
      { label: '备品备件', value: '备品备件' },
      { label: '印刷', value: '印刷' },
      { label: '物业服务', value: '物业服务' },
      { label: '房地产服务', value: '房地产服务' },
      { label: '物流行业', value: '物流行业' },
      { label: '工程总承包', value: '工程总承包' },
      { label: '物业管理服务', value: '物业管理服务' },
      { label: '汽车服务', value: '汽车服务' },
      { label: '房地产开发', value: '房地产开发' },
      { label: '工程机械租赁', value: '工程机械租赁' },
      { label: '保险', value: '保险' },
      { label: '物业管理', value: '物业管理' },
      { label: '文化传媒', value: '文化传媒' },
      { label: '化工制品', value: '化工制品' },
      { label: '保安服务', value: '保安服务' },
      { label: '通用设备', value: '通用设备' },
      { label: '环保行业', value: '环保行业' },
      { label: '美容护理', value: '美容护理' },
      { label: '工程机械', value: '工程机械' },
      { label: '餐饮服务', value: '餐饮服务' },
      { label: '保洁', value: '保洁' },
      { label: '食品饮料', value: '食品饮料' },
      { label: '医疗服务', value: '医疗服务' },
      { label: '印刷服务', value: '印刷服务' },
      { label: '仪器仪表', value: '仪器仪表' },
      { label: '会计审计', value: '会计审计' },
      { label: '水泥建材', value: '水泥建材' },
      { label: '餐饮业', value: '餐饮业' },
      { label: '工程服务', value: '工程服务' },
      { label: '交通服务', value: '交通服务' },
      { label: '市政基础设施工程', value: '市政基础设施工程' },
      { label: '维修', value: '维修' },
      { label: '电气元件', value: '电气元件' },
      { label: '防水工程', value: '防水工程' },
      { label: '铁路类、桥梁隧道类', value: '铁路类、桥梁隧道类' },
      { label: '光伏设备', value: '光伏设备' },
      { label: '钢铁行业', value: '钢铁行业' },
      { label: '铁路类', value: '铁路类' },
      { label: '公用事业', value: '公用事业' },
      { label: '运输服务', value: '运输服务' },
      { label: '保温材料', value: '保温材料' },
      { label: '法律服务', value: '法律服务' },
      { label: '交通运输', value: '交通运输' },
      { label: '医疗器械', value: '医疗器械' },
      { label: '办公用品', value: '办公用品' },
      { label: '能源(石油/石化/煤炭/新能源)', value: '能源(石油/石化/煤炭/新能源)' },
      { label: '办公设备', value: '办公设备' },
      { label: '能源行业', value: '能源行业' },
      { label: '家用轻工', value: '家用轻工' },
      { label: '家电行业', value: '家电行业' },
      { label: '装修建材', value: '装修建材' },
      { label: '电力行业', value: '电力行业' },
      { label: '软件开发', value: '软件开发' },
      { label: '办公家具', value: '办公家具' },
      { label: '辅助材料', value: '辅助材料' },
      { label: '服装行业', value: '服装行业' },
      { label: '其他服务', value: '其他服务' },
      { label: '石油行业', value: '石油行业' },
      { label: '水利工程', value: '水利工程' },
      { label: '水利水电工程施工', value: '水利水电工程施工' },
      { label: '建筑装修', value: '建筑装修' },
      { label: '综合行业', value: '综合行业' },
      { label: '冶金矿产', value: '冶金矿产' },
      { label: '电气成套设备及专用备件', value: '电气成套设备及专用备件' },
      { label: '废旧物资', value: '废旧物资' },
      { label: '铁路工程', value: '铁路工程' },
      { label: '物资材料类采购', value: '物资材料类采购' },
      { label: '农牧饲渔', value: '农牧饲渔' },
      { label: '水土流失治理', value: '水土流失治理' },
      { label: '印刷行业', value: '印刷行业' },
      { label: '能源金属', value: '能源金属' },
      { label: '服装', value: '服装' },
      { label: '工业气体', value: '工业气体' },
      { label: '建筑', value: '建筑' },
      { label: '交运设备', value: '交运设备' },
      { label: '消防技术', value: '消防技术' },
      { label: '广告制作', value: '广告制作' },
      { label: '会计师事务所执业', value: '会计师事务所执业' },
      { label: '工程->通用工程施工', value: '工程->通用工程施工' },
      { label: '工程->铁路工程', value: '工程->铁路工程' },
      { label: '煤炭行业', value: '煤炭行业' },
      { label: '建筑材料销售', value: '建筑材料销售' },
      { label: '餐饮用品', value: '餐饮用品' },
      { label: '金属制品', value: '金属制品' },
      { label: '保安', value: '保安' },
      { label: '给水排水', value: '给水排水' },
      { label: '非金属材料', value: '非金属材料' },
      { label: '广告服务', value: '广告服务' },
      { label: '电子设备', value: '电子设备' },
      { label: '空调设备', value: '空调设备' },
      { label: '铁路公路', value: '铁路公路' },
      { label: '农药兽药', value: '农药兽药' },
      { label: '金融行业', value: '金融行业' },
      { label: '化工', value: '化工' },
      { label: '其他印刷服务', value: '其他印刷服务' },
      { label: '酒店设备', value: '酒店设备' },
      { label: '建筑工程', value: '建筑工程' },
      { label: '建筑材料', value: '建筑材料' },
      { label: '印刷出版', value: '印刷出版' },
      { label: '环境污染处理', value: '环境污染处理' },
      { label: '家具行业', value: '家具行业' },
      { label: '空调租赁项目', value: '空调租赁项目' },
      { label: '燃气', value: '燃气' },
      { label: '消费电子', value: '消费电子' },
      { label: '服装服饰', value: '服装服饰' },
      { label: '半导体', value: '半导体' },
      { label: '体育用品', value: '体育用品' },
      { label: '化工辅料', value: '化工辅料' },
      { label: '燃油', value: '燃油' },
      { label: '纺织服装', value: '纺织服装' },
      { label: '市政公用工程', value: '市政公用工程' },
      { label: '印刷包装', value: '印刷包装' },
      { label: '化验室仪器及设备', value: '化验室仪器及设备' },
      { label: '广告宣传品制作', value: '广告宣传品制作' },
      { label: '五金制品', value: '五金制品' },
      { label: '工程建設', value: '工程建設' },
      { label: '餐饮', value: '餐饮' },
      { label: '家具', value: '家具' },
      { label: '服务类', value: '服务类' },
      { label: '绿化采购', value: '绿化采购' },
      { label: '旅游酒店', value: '旅游酒店' },
      { label: '交通设备', value: '交通设备' },
      { label: '航天航空', value: '航天航空' },
      { label: '工程造价', value: '工程造价' },
  ],
      page: {
        totalCount: 0,
        perPageSize: 20,
        currentPage: 1
      }
    };
  },
  methods: {
    getDetailLink(row) {
      return host + "get_company_info/" + row; // 动态生成链接
    },
    clickSearch() {
      this.page.currentPage = 1;
      this.fetchData();
    },
    resetSearchForm() {
      this.searchForm = {
        company_name: "",
        area: "",
        industry: "",
        question: ""
      };
      this.page.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.page.currentPage = page;
      this.fetchData();
    },
    fetchData() {
      const params = {
        ...this.searchForm,
        page: this.page.currentPage
      };
      axios.post(host + "get_company_info/", params)
        .then(response => {
          const data = response.data;
          this.tableData = data.data.results;
          this.page.totalCount = data.data.totalnum;
          console.log(this.tableData);
        })
        .catch(error => {
          console.error("Error fetching data: ", error);
        });
    },
    downloadExcel() {
      const params = {
        ...this.searchForm
      };
      axios({
        url: host + "download_excel",
        method: 'POST',
        responseType: 'blob', // 二进制数据
        data: params
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '招标信息.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch(error => {
        console.error("Error downloading excel: ", error);
      });
    },
    viewDetails(row) {
      const link = this.getDetailLink(row.id);
      window.open(link, '_blank');
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>
